var map = {
	"./3rdParty.svg": 299,
	"./Accident.svg": 300,
	"./Bicycle.svg": 301,
	"./Boat.svg": 302,
	"./Buildings.svg": 303,
	"./Car.svg": 304,
	"./Child.svg": 305,
	"./Contents.svg": 306,
	"./CriticalIllness.svg": 307,
	"./Dental.svg": 308,
	"./Drone.svg": 309,
	"./ExtendedWarranty.svg": 310,
	"./Family.svg": 311,
	"./Gadget.svg": 312,
	"./Health.svg": 313,
	"./Hospitalização.svg": 314,
	"./Housekeeper.svg": 315,
	"./Hunter.svg": 316,
	"./Income.svg": 317,
	"./Investment.png": 789,
	"./Investment.svg": 318,
	"./Life.svg": 319,
	"./LocalLodging.svg": 320,
	"./Mobile.svg": 321,
	"./Mortgage.svg": 322,
	"./Motorbike.svg": 323,
	"./Other.svg": 324,
	"./PPR.svg": 325,
	"./Pet.svg": 326,
	"./Ppr.png": 790,
	"./Scooter.svg": 327,
	"./Sports.png": 791,
	"./Sports.svg": 328,
	"./Thirdpartypet.png": 792,
	"./Thirdpartypet.svg": 329,
	"./Travel.svg": 330,
	"./Warranty.svg": 331,
	"./White_goods.svg": 332,
	"./WorkAccident.svg": 333,
	"./locallodging.png": 793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;